<!-- <app-sub-navbar></app-sub-navbar> -->
<app-nav-logo></app-nav-logo>

<div class="content">
    <div class="container-fluid">
        <div class="row mt-4">
            <div class="col-md-6 col-12"></div>
            <div class="col-md-6 col-12" style="text-align: right;">
                <button type="button" class="btn btn-success w-25 mr-3" data-toggle="modal"
                    data-target="#coopProfilePDF" (click)="onClickExport()">
                    รายงานการวิเคราะห์
                </button>
                <!-- ภาคการเกษตร
                <select class="form-select mr-3" name="list_sector" id="list_sector"
                    (change)="selectNewYearAndSector('',$event.target.value)" [(ngModel)]="sector_now">
                    <option *ngFor="let x of listsector" value="{{x.value}}">
                        {{x.name}}</option>
                </select> -->
                ข้อมูล ณ ปี
                <select class="form-select" name="list_year" id="list_year"
                    (change)="selectNewYearAndSector($event.target.value,'')" [(ngModel)]="year_now">
                    <option *ngFor="let y of listYear" value="{{y}}">{{y}}</option>
                </select>
            </div>
        </div>
        <div class="row">
            <div class="col-xl-7 col-lg-12 col-md-12 col-sm-12 col-xs-12 mt-3" *ngFor="let
                items of ProfileInfo">
                <div class="card">
                    <div class="card-header">
                        <h6 class="font-weight-bold">ข้อมูลทั่วไปสหกรณ์</h6>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 col-md-12 col-sm-12" style="text-align: right;">
                            <i class="fa fa-eye fa-2x" aria-hidden="true"
                                style="width: 25px; vertical-align: middle; padding-bottom: 2px; color: black;"></i>
                            จำนวนผู้เข้าชม : {{viewer}} ครั้ง
                        </div>
                        <h5 class="mt-3 text-center text-blacks">"{{items.coopNameTh}} จำกัด"
                        </h5>
                        <div class="col-xl-12 text-right">
                            <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                        </div>
                        <table class="w-100">
                            <tbody>
                                <tr>
                                    <td>
                                        <i class="fas fa-qrcode"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">รหัสสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.registryNo2 || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-file-signature"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ชื่อสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.coopNameTh}} จำกัด</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-layer-group"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ประเภทสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.coopTypeName || '-'}} ({{items.groupNameTh || '-'}})
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-map-marker-alt"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ที่อยู่
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : เลขที่ {{items.locAddr || '-'}} ตำบล{{items.tambonName || '-'}}
                                            อำเภอ{{items.amphurName || '-'}} จังหวัด{{items.provinceName || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-phone-volume"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">เบอร์โทรศัพท์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.tel}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-calendar"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">วันที่จดทะเบียนสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.registryDate || '-'}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-envelope"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">อีเมล
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.managerEmail || '-'}}</p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-check-circle"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">สถานะสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.coopStatusName || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-check-circle"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">มาตรฐานสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.stdCode
                                            == '1'">
                                            : ผ่านมาตรฐานสหกรณ์</p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.stdCode
                                            == '2'">
                                            : ไม่ผ่านมาตรฐานสหกรณ์</p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.stdCode
                                            == '3'">
                                            : ไม่นำมาจัดมาตรฐานสหกรณ์
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-check-circle"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ระดับชั้นสหกรณ์ตามระดับความเข้มแข็ง
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                        ml-3">
                                            : {{items.coopLevel || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr *ngIf="items.coopStandard ==
                                    '3'">
                                    <td>
                                        <i class="fas fa-list"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">มาตรฐานสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.coopStandardDetail
                                            ==
                                            'no_count1'">เหตุที่ไม่นำมาจัดมาตรฐานสหกรณ์ : จัดตั้งใหม่ไม่ถึง 2 ปี</p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.coopStandardDetail
                                            ==
                                            'no_count2'">เหตุที่ไม่นำมาจัดมาตรฐานสหกรณ์ : หยุดดำเนินกิจการ
                                        </p>
                                        <p class="mt-auto mb-auto
                                            ml-3" *ngIf="items.coopStandardDetail
                                            ==
                                            'no_count3'">เหตุที่ไม่นำมาจัดมาตรฐานสหกรณ์ : อยู่ระหว่างชำระบัญชี
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-poll"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">จำนวนหุ้น
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.stock | number:'':'he'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-coins"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">มูลค่าหุ้น
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : {{items.amtStock | number:'':'he'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas
                                            fa-calendar-alt"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">วันสิ้นปีทางบัญชี
                                        </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '1'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : มกราคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '2'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : กุมภาพันธ์ </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '3'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : มีนาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '4'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : เมษายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '5'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : พฤษภาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '6'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : มิถุนายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '7'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : กรกฎาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '8'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : สิงหาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '9'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : กันยายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '10'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : ตุลาคม </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '11'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : พฤศจิกายน </p>
                                    </td>
                                    <td *ngIf="items.acctMonthEnd ==
                                        '12'">
                                        <p class="mt-auto mb-auto
                                            ml-3">
                                            : ธันวาคม </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-user-tag"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ประธานกรรมการสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.committeeTitle || '-'}} {{items.committeeName || '-'}}
                                            {{items.committeeSname || '-'}}
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-user-tag"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">จำนวนพนักงาน
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.officer || '-'}} คน
                                        </p>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <i class="fas fa-user-tag"></i>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3">ผู้จัดการสหกรณ์
                                        </p>
                                    </td>
                                    <td>
                                        <p class="mt-auto mb-auto
                                            ml-3"> : {{items.managerTitle || '-'}} {{items.managerName || '-'}}
                                            {{items.managerSname || '-'}}
                                        </p>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>

            <div class="col-xl-5 col-lg-12 col-md-12 col-sm-12 col-xs-12" *ngFor="let
                items of
                ProfileInfo">
                <div class="row">
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-4">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="font-weight-bold">จำนวนสมาชิกสหกรณ์</h6>
                            </div>
                            <div class="card-body p-3">
                                <div class="row p-0 m-0">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                        </p>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-md-12
                                        col-sm-12
                                        d-flex">
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">ชาย {{items.memberM | number:'':'he'}}
                                                คน
                                            </h6>
                                            <!-- <h6 class="number">ชาย {{items.memberM+items.memberJoinM | number:'':'he'}}
                                                คน
                                            </h6> -->
                                            <img src="/assets/images/user_1.png" class="member mt-3" alt="">
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">หญิง {{items.memberFm |
                                                number:'':'he'}} คน
                                            </h6>
                                            <!-- <h6 class="number">หญิง {{items.memberFm+items.memberJoinFm |
                                                number:'':'he'}} คน
                                            </h6> -->
                                            <img src="/assets/images/user_2.png" class="member mt-3" alt="">
                                        </div>
                                    </div>
                                    <div class="col-xl-12 col-lg-12 col-lg-12
                                        text-center mt-4">
                                        <h5>รวม {{items.member | number:'':'he'}}
                                            {{items.coopFederation && items.coopFederation == 'Y' ? 'สหกรณ์' : 'คน'}}
                                        </h5>
                                        <!-- <h5>รวม {{items.member+items.memberJoin | number:'':'he'}}
                                            {{items.coopFederation && items.coopFederation == 'Y' ? 'สหกรณ์' : 'คน'}}
                                        </h5> -->
                                    </div>
                                    <!-- <div class="col-xl-12 col-lg-12 col-lg-12
                                    text-center mt-4">
                                        <h6>*จำนวนสมาชิกสหกรณ์รวมสมาชิกที่ร่วมธุรกิจกับสหกรณ์</h6>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 mt-4">
                        <div class="card h-100">
                            <div class="card-header">
                                <h6 class="font-weight-bold">จำนวนกรรมการสหกรณ์</h6>
                            </div>
                            <div class="card-body p-3">
                                <div class="col-xl-12 text-right">
                                    <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                    </p>
                                </div>
                                <div class="row p-0 m-0">
                                    <div class="col-xl-12 col-lg-12 col-md-12
                                        col-sm-12
                                        d-flex">
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">ชาย {{items.committeeM | number:'':'he'}} คน</h6>
                                            <img src="/assets/images/employee_2.png" class="member mt-3" alt="">
                                        </div>
                                        <div class="col-xl-6 col-lg-6 col-md-6
                                            text-center p-0">
                                            <h6 class="number">หญิง {{items.committeeFm | number:'':'he'}} คน</h6>
                                            <img src="/assets/images/employee_1.png" class="member mt-3" alt="">
                                        </div>
                                    </div>
                                    <div class="col-lg-12 col-lg-12
                                        text-center mt-4">
                                        <h5>รวม {{SumCommittee | number:'':'he'}} คน</h5>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row" *ngIf="defect_on == true && defect_verify == true">
                    <div class="col-xl-12 col-md-12 col-sm-12 mt-4">
                        <div class="card">
                            <div class="card-header">
                                <h6 class="font-weight-bold">ข้อบกพร่อง</h6>
                            </div>
                            <div class="card-body p-3">
                                <div class="col-xl-12 text-right">
                                    <h6 class="text-center p-2 mt-3">ข้อมูล ณ
                                        วันที่
                                        {{Date_after_day}} {{Month_now}}
                                        {{year_now_}}
                                    </h6>
                                </div>
                                <div class="col-lg-12 col-md-12 col-sm-12
                                text-center mt-5" *ngIf="check_Data == true">
                                    <p>- ไม่พบข้อบกพร่อง -</p>
                                </div>
                                <table class="table table-hover" *ngIf="check_Data == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th width="15%"> ลำดับที่ </th>
                                            <th> หัวข้อ </th>
                                            <th> สถานะ </th>
                                        </tr>
                                    </thead>

                                    <tbody *ngFor="let items of CoopDefect;
                                        index
                                        as i">
                                        <tr>
                                            <td>
                                                <p>{{i+1}}</p>
                                            </td>
                                            <td>
                                                <p>{{items.defectSubjectDetail}}</p>
                                            </td>
                                            <td>
                                                <p>{{items.solvMainDetail}}</p>
                                            </td>
                                        </tr>

                                    </tbody>
                                </table>
                                <!-- <div class="col-xl-12 text-right">
                                    <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="card-header">
                        <b>งบแสดงฐานะทางการเงิน</b>
                    </div>
                    <div class="row pl-2 pr-2 mb-2">
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    สินทรัพย์ของสหกรณ์
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{netAssets_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    หนี้สินของสหกรณ์
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{liabilities_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv2"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    ทุนของสหกรณ์
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{coopCapital_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv3"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-12 col-sm-12 mt-4">
                            <div class="card">
                                <div class="card-header">
                                    กำไร (ขาดทุน)ของสหกรณ์
                                </div>
                                <div class="card-body">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>

                                    <!-- <div class="row">
                                        <div class="col-xl-12">
                                            <h4 class="text-center">{{netProfit_year_now | number:'':'he'}} บาท</h4>
                                        </div>
                                    </div> -->
                                    <div class="row">
                                        <div class="col-xl-12 p-0">
                                            <div id="chartdiv4"></div>
                                        </div>
                                    </div>
                                    <!-- <div class="col-xl-12 text-right">
                                        <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row"
            *ngIf="depositVal1Show == true || creditVal1Show == true || saleVal1Show == true || collectVal1Show == true || transformVal1Show == true || serviceVal1Show == true">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="card-header">
                        <b>ปริมาณธุรกิจสหกรณ์</b>
                    </div>
                    <div class="row pl-2 pr-2 mb-2">
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="depositVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรับฝากเงิน
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_deposit"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="creditVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทให้เงินกู้
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_lend">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="saleVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทจัดหาสินค้ามาจำหน่าย
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_products">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="collectVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทรวบรวมผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_produce">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="transformVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทแปรรูปผลผลิต
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_Processing">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-4 col-md-6 col-sm-12 mt-4" *ngIf="serviceVal1Show == true">
                            <div class="card h-100">
                                <div class="card-header pb-0">
                                    <h6 class="font-weight-bold">ปริมาณธุรกิจ ประเภทธุรกิจบริการ
                                    </h6>
                                </div>
                                <div class="card-body p-0">
                                    <div class="col-xl-12">
                                        <div id="chartdiv_business_service">

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row"
            *ngIf="memberBusinessShow == true || memDepositShow == true || memCreditShow == true || memSaleShow == true || memGoodShow == true || memMarketingShow == true || memServiceShow == true || memOtherShow == true">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="card-header">
                        <b>การมีส่วนร่วมทำธุรกิจกับสหกรณ์ของสมาชิก</b>
                    </div>
                    <div class="row pl-2 pr-2 mb-2">
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memberBusinessShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memDepositShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรับฝากเงิน
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Deposit">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memCreditShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทสินเชื่อ
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Credit">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memSaleShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทจัดหาสินค้ามาจำหน่าย
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Sale">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memGoodShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทแปรรูปผลผลิต
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Good">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memMarketingShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทรวบรวมผลผลิต
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Mageting">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memServiceShow == true">
                            <div class="card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทธุรกิจบริการ
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Service">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                        <div class="col-xl-3 col-md-6 col-sm-12 mt-4" *ngIf="memOtherShow == true">
                            <div class=" card h-100">
                                <div class="card-header">
                                    การมีส่วนร่วมของสมาชิกสหกรณ์ ประเภทธุรกิจอื่น ๆ
                                </div>
                                <div class="card-body p-3">
                                    <div class="col-xl-12 text-right">
                                        <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}</p>
                                    </div>
                                    <div>
                                        <div id="chartdiv_Pratic_Other">

                                        </div>
                                    </div>
                                    <p class="text-center" *ngIf="">- ไม่พบการขึ้นทะเบียน -</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row mt-4" *ngIf="statusSector == 'สหกรณ์ภาคการเกษตร'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="tab">
                        <ul class="nav nav-tabs">
                            <li class="">
                                <a class="" id="asset" (click)="Assets($event.target.id)" [ngClass]="(asset ==
                                    true) ? 'active' : ''">อุปกรณ์การตลาด</a>
                            </li>
                            <li class="">
                                <a class="" id="machine" (click)="Machine($event.target.id)" [ngClass]="(machine ==
                                    true)?'active' : ''">เครื่องจักรกลการเกษตร</a>
                            </li>
                        </ul>
                    </div>
                    <ng-container *ngIf="asset">
                        <div class="card-header">
                            <p>อุปกรณ์การตลาด </p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12
                                text-center" *ngIf="check_Length_3 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="row">
                                <div class="col-xl-12 col-lg-12 col-md-6
                                    col-sm-12">
                                    <div class="table-responsive">
                                        <table class="table table-hover" *ngIf="check_Length_3
                                            == false">
                                            <thead>
                                                <tr class="table-active">
                                                    <th scope="col">ลำดับ</th>
                                                    <th scope="col">รายการอุปกรณ์การตลาด</th>
                                                    <th scope="col">การใช้ประโยชน์</th>
                                                    <th scope="col">จำนวน</th>
                                                    <th scope="col">หน่วยนับ (จำนวน)
                                                    </th>
                                                    <th scope="col">กำลังการผลิต</th>
                                                    <th scope="col">หน่วยนับ (จำนวน)
                                                    </th>
                                                    <th scope="col">งบปี</th>
                                                    <th scope="col">โครงการ</th>
                                                </tr>
                                            </thead>
                                            <tbody *ngFor="let items of
                                                AssetYear; index
                                                as
                                                i">
                                                <tr>
                                                    <th scope="row" class="table-active">{{i+1}}</th>
                                                    <th scope="row">{{items.assetDesc}}</th>
                                                    <th scope="row">{{items.rvMeaningStatus}}</th>
                                                    <th scope="row">{{items.qty | number:'':'he'}}
                                                    </th>
                                                    <th scope="row">{{items.qtyUom}}</th>
                                                    <th scope="row">{{items.size | number:'':'he'}}
                                                    </th>
                                                    <th scope="row">{{items.sizeUom}}</th>
                                                    <th scope="row">{{items.purchaseYear}}</th>
                                                    <th scope="row">{{items.bgtRemark}}
                                                    </th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-xl-12 text-right">
                                <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                            </div> -->
                        </div>
                    </ng-container>

                    <ng-container *ngIf="machine">
                        <div class="card-header">
                            <p>เครื่องจักรกลการเกษตร</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12
                                text-center" *ngIf="check_Length_4 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover" *ngIf="check_Length_4
                                    == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">รายการเครื่องจักรกลการเกษตร</th>
                                            <th scope="col">การใช้ประโยชน์</th>
                                            <th scope="col">จำนวน</th>
                                            <th scope="col">หน่วยนับ (จำนวน)
                                            </th>
                                            <th scope="col">กำลังการผลิต</th>
                                            <th scope="col">หน่วยนับ (จำนวน)
                                            </th>
                                            <th scope="col">การนำไปใช้งาน</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let items of
                                            MachinesByRegister;
                                            index
                                            as
                                            i">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.assetDesc}}</th>
                                            <th scope="row">{{items.rvMeaningStatus}}</th>
                                            <th scope="row">{{items.agriQty | number:'':'he'}}
                                            </th>
                                            <th scope="row">{{items.agriQtyUom}}</th>
                                            <th scope="row">{{items.agriSize | number:'':'he'}}
                                            </th>
                                            <th scope="row">{{items.agriSizeUom}}</th>
                                            <th scope="row">{{items.rvMeaningStep}}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <!-- <div class="col-xl-12 text-right">
                                <p>ที่มา : กรมส่งเสริมสหกรณ์</p>
                            </div> -->
                        </div>
                    </ng-container>
                </div>
            </div>
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 mt-4">
                <div class="card">
                    <div class="tab">
                        <ul class="nav nav-tabs">
                            <li class="">
                                <a class="" id="cpd" (click)="CPD($event.target.id)" [ngClass]="(cpd ==
                                    true)?'active' : ''">ข้อมูลพื้นที่เพาะปลูก
                                </a>
                            </li>
                        </ul>
                    </div>

                    <!-- <ng-container *ngIf="rice">
                        <div class="card-header">
                            <p>พื้นที่เพาะปลูกข้าว</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">พื้นที่เพาะปลูก ข้าว (ไร่)</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let items of ViewRiceOracleSumYear;
                                        index
                                        as
                                        i">
                                        <tr *ngIf="i >= 0">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.totalRai | number:'':'he'}}
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container> -->

                    <!-- <ng-container *ngIf="rubber">
                        <div class="card-header">
                            <p>พื้นที่เพาะปลูกยาง</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">พื้นที่เพาะปลูก ยาง (ไร่)</th>
                                        </tr>
                                    </thead>
                                    <tbody *ngFor="let items of ViewRubberOracleSumYear;
                                        index
                                        as
                                        i">
                                        <tr *ngIf="i >= 0">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.totalRai | number:'':'he'}}
                                            </th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container> -->

                    <ng-container *ngIf="cpd">
                        <div class="card-header">
                            <p>พื้นที่</p>
                        </div>
                        <div class="card-body p-3">
                            <!-- <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div> -->
                            <div class="col-lg-12 col-md-12 col-sm-12 text-center" *ngIf="check_Length_2 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover" *ngIf="check_Length_2 == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col"></th>
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">ประเภท</th>
                                            <th scope="col">จำนวนสมาชิก (คน)</th>
                                            <th scope="col">พื้นที่เพาะปลูก (ไร่)</th>
                                        </tr>
                                    </thead>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนเกษตรกร
                                    </th>
                                    <tbody *ngFor="let items of ViewOaeOracleSumYear; index as i">
                                        <tr *ngIf="items.groupCode == '1' ">
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '1' ">{{items.type}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '1' ">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row" *ngIf="items.groupCode == '1' ">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g1 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active">
                                        ทะเบียนเลี้ยงสัตว์</th>
                                    <tbody *ngFor="let items of ViewOaeOracleSumYear; index as i">
                                        <tr *ngIf="items.groupCode == '2' ">
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '2' ">{{items.typeDetail}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '2' ">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row" *ngIf="items.groupCode == '2' ">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g2 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนประมง</th>
                                    <tbody *ngFor="let items of ViewOaeOracleSumYear; index as i">
                                        <tr *ngIf="items.groupCode == '3' ">
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '3' ">{{items.typeDetail}}</td>
                                            <td scope="row" *ngIf="items.groupCode == '3' ">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row" *ngIf="items.groupCode == '3' ">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g3 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>

                                    <th scope="row" colspan="5" class="font-weight-bold table-active"> ทะเบียนผู้ปลูกยาง
                                    </th>
                                    <tbody *ngFor="let items of ViewRubberOracleSumYear; index as i">
                                        <tr>
                                            <th></th>
                                            <td scope="row" class="table-active">{{i+1}}</td>
                                            <td scope="row">ยาง</td>
                                            <td scope="row">{{items.totalCount |
                                                number:'':'he'}} </td>
                                            <td scope="row">{{items.totalRai |
                                                number:'':'he'}} </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <tr *ngIf="check_Length_g4 == true">
                                            <th></th>
                                            <td scope="row" class="table-active">- ไม่พบการขึ้นทะเบียน - </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>
                </div>
            </div>
        </div>

        <div class="row mt-4" *ngIf="statusSector == 'สหกรณ์นอกภาคการเกษตร'">
            <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                <div class="card mt-5">
                    <div class="tab">
                        <ul class="nav nav-tabs">
                            <li class="">
                                <a class="" id="product" [ngClass]="(product ==
                                    true)?'active' : ''" (click)="Product($event.target.id)">รวบรวมผลผลิต</a>
                            </li>
                        </ul>
                    </div>

                    <ng-container *ngIf="product">
                        <div class="card-header">
                            <p>รวบรวมผลผลิต</p>
                        </div>
                        <div class="card-body p-3">
                            <div class="col-xl-12 text-right">
                                <p class="text-black-50">ข้อมูล ณ ปี {{year_now}}
                                </p>
                            </div>
                            <div class="col-lg-12 col-md-12 col-sm-12
                                text-center" *ngIf="check_Length_5 == true">
                                <p>- ไม่พบการขึ้นทะเบียน -</p>
                            </div>
                            <div class="table-responsive">
                                <table class="table table-hover" *ngIf="check_Length_5
                                    == false">
                                    <thead>
                                        <tr class="table-active">
                                            <th scope="col">ลำดับ</th>
                                            <th scope="col">รายการรวบรวมลำดับที่ 1
                                            </th>
                                            <th scope="col">รายการรวบรวมลำดับที่ 2
                                            </th>
                                            <th scope="col">รายการรวบรวมลำดับที่ 3
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let items of CollectYear;
                                            index
                                            as
                                            i">
                                            <th scope="row" class="table-active">{{i+1}}</th>
                                            <th scope="row">{{items.collect1}}</th>
                                            <th scope="row">{{items.collect2}}</th>
                                            <th scope="row">{{items.collect3}}</th>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </ng-container>

                </div>
            </div>
        </div>
    </div>
    <app-footer></app-footer>
</div>


<ngx-spinner bdColor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
    <p style="color: white">กรุณารอสักครู่. </p>
</ngx-spinner>






<!-- Modal PDF -->
<div class="modal fade" id="coopProfilePDF" tabindex="-1" role="dialog">
    <div class="modal-dialog " role="document">
        <div class="modal-content modal-content-body">
            <div class="container-fluid p-2">

                <div class="a4-size" id="coopPdf">

                    <div class="container-fluid p-2" *ngIf="pdfPage == 0">
                        <img class="bg-1" src="assets/pdf/A4-5.png" alt="">
                        <div class="row">
                            <div class="col title-pdf" style="color: #38008D;">
                                สรุปรายงานการวิเคราะห์ผล
                                <br>
                                {{ProfileInfo && ProfileInfo.length > 0 ? ProfileInfo[0].coopNameTh : ''}} จำกัด
                            </div>
                            <div class="col" style="text-align: end;">
                                <img class="logo-pdf" src="assets/pdf/image70.png" alt="">
                            </div>
                        </div>

                        <div class="row ml-2 mr-2 mt-2 profile-pdf">
                            <div class="col-7 pr-0" style="border-radius: 10px 0 10px 0;">
                                <ul class="profile-pdf-list" *ngFor="let
                                items of ProfileInfo">
                                    <li><span>รหัสสหกรณ์ : {{items.registryNo2}}</span></li>
                                    <li><span>ประเภท : {{items.coopTypeName}} ({{ items.groupNameTh }})</span></li>
                                    <li><span>ที่อยู่ : เลขที่ {{items.locAddr || '-'}} ตำบล{{items.tambonName || '-'}}
                                            อำเภอ{{items.amphurName || '-'}} จังหวัด{{items.provinceName || '-'}}
                                        </span></li>
                                    <li><span>เบอร์โทรศัพท์ : {{items.tel}}</span></li>
                                    <li><span>วันที่ปิดบัญชี : {{monthNamesThai[items.acctMonthEnd -1]}}</span></li>
                                    <li><span>สินค้าหลักของสหกรณ์ 3 อันดับ : {{coopMk}}</span></li>
                                    <li><span>สินค้าแปรรูป 3 อันดับแรก : {{coopGood}}</span></li>
                                    <li><span>ระดับชั้นสหกรณ์ตามระดับความเข้มแข็ง : {{items.coopLevel}}</span></li>
                                    <li><span>วันที่จดทะเบียนสหกรณ์ : {{items.registryDate}}</span></li>
                                    <li><span>จำนวน / มูลค่าหุ้น : {{items.stock | number:'':'he'}} / {{items.amtStock |
                                            number:'':'he'}}</span></li>
                                    <li><span>ประธานกรรมการ : {{items.committeeTitle || '-'}} {{items.committeeName ||
                                            '-'}} {{items.committeeSname || '-'}}</span></li>
                                    <li><span>ผู้จัดการสหกรณ์ :{{items.managerTitle || '-'}} {{items.managerName ||
                                            '-'}} {{items.managerSname || '-'}}</span></li>
                                    <!-- <li><span>สมาชิก ช/ญ : {{items.memberM+items.memberJoinM |
                                            number:'':'he'}}/{{items.memberFm+items.memberJoinFm | number:'':'he'}} คน
                                            รวม {{items.member+items.memberJoin | number:'':'he'}} คน</span></li> -->
                                    <li><span>กรรมการ ช/ญ : {{items.committeeM | number:'':'he'}}/{{items.committeeFm |
                                            number:'':'he'}} คน รวม {{SumCommittee | number:'':'he'}} คน</span></li>
                                </ul>
                            </div>
                            <div class="col-5">
                                <img class="people-pdf" src="assets/pdf/Group4573.png" alt="">
                            </div>

                            <div class="col-2 ml-3 mr-3 text-center box-blue mt-2">
                                จำนวนสมาชิก
                                <br>
                                {{Coop_memberzone && Coop_memberzone.length > 0 ? Coop_memberzone[0] : '-'}}
                            </div>
                            <div class="col-2 ml-3 mr-3 text-center box-blue mt-2">
                                ขนาดสินทรัพย์
                                <br>
                                {{Coop_memberzone && Coop_memberzone.length > 0 ? Coop_memberzone[1] : '-'}}
                            </div>
                            <div class="col text-center mt-2">
                                หลักการคำนวณ Percentile มีการคำนวณดังนี้
                                <br>
                                <20 S, 21-40 M, 41-60 L, 61-80 XL,>80 xxl
                            </div>
                        </div>

                        <div class="row" style="margin-top: 5rem !important;">
                            <div class="col text-center">
                                <img class="group-img-title" src="assets/pdf/Grou34225.png" alt="">
                            </div>
                        </div>

                        <ng-container *ngFor="let items of Coop_Reportbalance">
                            <div class="row ml-2 mr-2">
                                <div class="col-8 mt-3">
                                    <span class="pdf-text-green">สินทรัพย์สหกรณ์</span>
                                    <span class="pdf-text-red"> ปี
                                        {{items.netasset_year_now}}</span> จำนวน
                                    {{items.netasset_year_now_num.toLocaleString("en-US")}} ลบ.
                                    <span class="pdf-text-red">
                                        {{items.netasset_compare}}</span>
                                    จาก<span class="pdf-text-red">ปี
                                        {{items.netasset_year_last}}</span> จำนวน
                                    {{items.netasset_year_last_num.toLocaleString("en-US")}} ลบ.
                                    คิดเป็น {{items.netasset_cal_percent}}%
                                    จากข้อมูลปี {{items.netasset_year_low}} – {{items.netasset_year_max}} พบว่าปี
                                    {{items.netasset_year_low}} มีค่าต่ำสุดที่
                                    {{items.netasset_year_low_num.toLocaleString("en-US")}} ลบ.
                                    และสูงสุดที่ปี {{items.netasset_year_max}}
                                    จำนวน {{items.netasset_year_max_num.toLocaleString("en-US")}} ลบ.
                                </div>
                                <div class="col-4"></div>
                                <div class="col-8 mt-3">
                                    <span class="pdf-text-green">หนี้สิน</span>
                                    <span class="pdf-text-red"> ปี
                                        {{items.liabilities_year_now}}</span> จำนวน
                                    {{items.liabilities_year_now_num.toLocaleString("en-US")}}
                                    ลบ.
                                    <span class="pdf-text-red">
                                        {{items.liabilities_compare}}</span>
                                    จาก<span class="pdf-text-red">ปี
                                        {{items.liabilities_year_last}}</span> จำนวน
                                    {{items.liabilities_year_last_num.toLocaleString("en-US")}}
                                    ลบ.
                                    คิดเป็น {{items.liabilities_cal_percent}}%
                                    จากข้อมูลปี {{items.liabilities_year_low}} – {{items.liabilities_year_max}} พบว่าปี
                                    {{items.liabilities_year_low}} มีค่าต่ำสุดที่
                                    {{items.liabilities_year_low_num.toLocaleString("en-US")}} ลบ.
                                    และสูงสุดที่ปี {{items.liabilities_year_max}}
                                    จำนวน {{items.liabilities_year_max_num.toLocaleString("en-US")}} ลบ.
                                </div>
                                <div class="col-4"></div>
                                <div class="col-4"></div>
                                <div class="col-8 mt-3">
                                    <span class="pdf-text-green">ทุน</span>
                                    <span class="pdf-text-red"> ปี
                                        {{items.capital_year_now}}</span> จำนวน
                                    {{items.capital_year_now_num.toLocaleString("en-US")}} ลบ.
                                    <span class="pdf-text-red">
                                        {{items.capital_compare}}</span>
                                    จาก<span class="pdf-text-red">ปี
                                        {{items.capital_year_last}}</span> จำนวน
                                    {{items.capital_year_last_num.toLocaleString("en-US")}} ลบ.
                                    คิดเป็น {{items.capital_cal_percent}}%
                                    จากข้อมูลปี {{items.capital_year_low}} – {{items.capital_year_max}} พบว่าปี
                                    {{items.capital_year_low}} มีค่าต่ำสุดที่
                                    {{items.capital_year_low_num.toLocaleString("en-US")}} ลบ.
                                    และสูงสุดที่ปี {{items.capital_year_max}}
                                    จำนวน {{items.capital_year_max_num.toLocaleString("en-US")}} ลบ.
                                </div>
                                <div class="col-4"></div>
                                <div class="col-8 mt-3">
                                    <span class="pdf-text-green">กำไร</span>
                                    <span class="pdf-text-red"> ปี
                                        {{items.profit_year_now}}</span> จำนวน
                                    {{items.profit_year_now_num.toLocaleString("en-US")}} ลบ.
                                    <span class="pdf-text-red">
                                        {{items.profit_compare}}</span>
                                    จาก<span class="pdf-text-red">ปี
                                        {{items.profit_year_last}}</span> จำนวน
                                    {{items.profit_year_last_num.toLocaleString("en-US")}} ลบ.
                                    คิดเป็น {{items.profit_cal_percent}}%
                                    จากข้อมูลปี {{items.profit_year_low}} – {{items.profit_year_max}} พบว่าปี
                                    {{items.profit_year_low}} มีค่าต่ำสุดที่
                                    {{items.profit_year_low_num.toLocaleString("en-US")}} ลบ.
                                    และสูงสุดที่ปี {{items.profit_year_max}}
                                    จำนวน {{items.profit_year_max_num.toLocaleString("en-US")}} ลบ.
                                </div>
                            </div>
                        </ng-container>

                        <div class="row mt-3">
                            <div class="col-10">
                                <table class="table pdf-tbl">
                                    <thead class="pdf-tbl-detail">
                                        <tr>
                                            <th class="p-1 text-center pdf-tbl-detail" rowspan="2"
                                                style="vertical-align: middle; border-left: 3.5px solid #FE5E54 !important; border-right: 3.5px solid #FE5E54 !important;">
                                                CAEL/สหกรณ์</th>
                                            <th class="p-1 text-center pdf-tbl-detail" colspan="2">AVG/สมาชิก</th>
                                            <th class="p-1 text-center pdf-tbl-detail" colspan="2">AVG/สินทรัพย์</th>
                                            <th class="p-1 text-center pdf-tbl-detail" colspan="2"
                                                style="border-right: 3.5px solid #FE5E54 !important;">AVG/จังหวัด</th>
                                        </tr>
                                        <tr>
                                            <th class="p-1 text-center pdf-tbl-detail" style="font-size: 8px;">
                                                ในภาคการเกษตร</th>
                                            <th class="p-1 text-center pdf-tbl-detail" style="font-size: 8px;">
                                                นอกภาคการเกษตร</th>
                                            <th class="p-1 text-center pdf-tbl-detail" style="font-size: 8px;">
                                                ในภาคการเกษตร</th>
                                            <th class="p-1 text-center pdf-tbl-detail" style="font-size: 8px;">
                                                นอกภาคการเกษตร</th>
                                            <th class="p-1 text-center pdf-tbl-detail" style="font-size: 8px;">
                                                ในภาคการเกษตร</th>
                                            <th class="p-1 text-center pdf-tbl-detail"
                                                style="font-size: 8px; border-right: 3.5px solid #FE5E54 !important;">
                                                นอกภาคการเกษตร</th>
                                        </tr>
                                    </thead>
                                    <tbody class="pdf-tbl-detail" *ngFor="let items of Coop_Report_Cael">
                                        <tr>
                                            <th class="text-center pdf-tbl-detail"
                                                style="border-left: 3.5px solid #FE5E54 !important;">ROA</th>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[0]}})
                                                {{items.roA_member_in}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[0]}})
                                                {{items.roA_member_out}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[1]}})
                                                {{items.roA_netasset_in}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[1]}})
                                                {{items.roA_netasset_out}}</td>
                                            <td class="text-center pdf-tbl-detail">{{items.roA_province_in}}</td>
                                            <td class="text-center pdf-tbl-detail"
                                                style="border-right: 3.5px solid #FE5E54 !important;">
                                                {{items.roA_province_out}}</td>
                                        </tr>
                                        <tr>
                                            <th class="text-center pdf-tbl-detail"
                                                style="border-left: 3.5px solid #FE5E54 !important;">ROE</th>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[0]}})
                                                {{items.roE_member_in}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[0]}})
                                                {{items.roE_member_out}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[1]}})
                                                {{items.roE_netasset_in}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[1]}})
                                                {{items.roE_netasset_out}}</td>
                                            <td class="text-center pdf-tbl-detail">{{items.roE_province_in}}</td>
                                            <td class="text-center pdf-tbl-detail"
                                                style="border-right: 3.5px solid #FE5E54 !important;">
                                                {{items.roE_province_out}}</td>
                                        </tr>
                                        <tr>
                                            <th class="text-center pdf-tbl-detail"
                                                style="border-left: 3.5px solid #FE5E54 !important;">D/E</th>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[0]}})
                                                {{items.dE_member_in}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[0]}})
                                                {{items.dE_member_out}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[1]}})
                                                {{items.dE_netasset_in}}</td>
                                            <td class="text-center pdf-tbl-detail">({{Coop_memberzone[1]}})
                                                {{items.dE_netasset_out}}</td>
                                            <td class="text-center pdf-tbl-detail">{{items.dE_province_in}}</td>
                                            <td class="text-center pdf-tbl-detail"
                                                style="border-right: 3.5px solid #FE5E54 !important;">
                                                {{items.dE_province_out}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div class="container-fluid p-2" *ngIf="pdfPage == 1">
                        <img class="bg-1" src="assets/pdf/A4-7.png" alt="">

                        <div class="row mt-3">
                            <div class="col text-center">
                                <img class="group-img-title" src="assets/pdf/Group4539.png" alt="">
                            </div>
                        </div>

                        <ng-container *ngFor="let items of Coop_ReportBussinessProfile">
                            <div class="row ml-2 mr-2">
                                <div class="col-6" style="margin-top: 20px;">
                                    <!-- <img class="people-pdf" src="assets/pdf/Group34224.png" alt=""> -->
                                    <div id="chartdivPDF1" class="chart"></div>
                                </div>
                                <div class="col-6 mt-3 pt-2 profile-pdf2">
                                    <ul class="profile-pdf-list2">
                                        <li>
                                            <span class="pdf-text-green">ประเภทรับฝากเงิน</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.depositVal1_year_now}}</span> จำนวน
                                            {{items.depositVal1_year_now_num.toLocaleString("en-US")}} ลบ.
                                            <span class="pdf-text-red">
                                                {{items.depositVal1_compare}}</span>
                                            จาก<span class="pdf-text-red">ปี
                                                {{items.depositVal1_year_last}}</span> จำนวน
                                            {{items.depositVal1_year_last_num.toLocaleString("en-US")}}
                                            ลบ.
                                            คิดเป็น {{items.depositVal1_cal_percent}}%
                                            จากข้อมูลปี {{items.depositVal1_year_low}} – {{items.depositVal1_year_max}}
                                            พบว่าปี
                                            {{items.depositVal1_year_low}} มีค่าต่ำสุดที่
                                            {{items.depositVal1_year_low_num.toLocaleString("en-US")}} ลบ.
                                            และสูงสุดที่ปี {{items.depositVal1_year_max}}
                                            จำนวน {{items.depositVal1_year_max_num.toLocaleString("en-US")}} ลบ.
                                        </li>

                                        <li>
                                            <span class="pdf-text-green">ประเภทให้เงินกู้</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.creditVal1_year_now}}</span> จำนวน
                                            {{items.creditVal1_year_now_num.toLocaleString("en-US")}} ลบ.
                                            <span class="pdf-text-red">
                                                {{items.creditVal1_compare}}</span>
                                            จาก<span class="pdf-text-red">ปี
                                                {{items.creditVal1_year_last}}</span> จำนวน
                                            {{items.creditVal1_year_last_num.toLocaleString("en-US")}}
                                            ลบ.
                                            คิดเป็น {{items.creditVal1_cal_percent}}%
                                            จากข้อมูลปี {{items.creditVal1_year_low}} – {{items.creditVal1_year_max}}
                                            พบว่าปี
                                            {{items.creditVal1_year_low}} มีค่าต่ำสุดที่
                                            {{items.creditVal1_year_low_num.toLocaleString("en-US")}} ลบ.
                                            และสูงสุดที่ปี {{items.creditVal1_year_max}}
                                            จำนวน {{items.creditVal1_year_max_num.toLocaleString("en-US")}} ลบ.
                                        </li>

                                        <li>
                                            <span class="pdf-text-green">ประเภทจัดหาสินค้ามาจำหน่าย</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.saleVal1_year_now}}</span> จำนวน
                                            {{items.saleVal1_year_now_num.toLocaleString("en-US")}}
                                            ลบ.
                                            <span class="pdf-text-red">
                                                {{items.saleVal1_compare}}</span>
                                            จาก<span class="pdf-text-red">ปี
                                                {{items.saleVal1_year_last}}</span> จำนวน
                                            {{items.saleVal1_year_last_num.toLocaleString("en-US")}}
                                            ลบ.
                                            คิดเป็น {{items.saleVal1_cal_percent}}%
                                            จากข้อมูลปี {{items.saleVal1_year_low}} – {{items.saleVal1_year_max}}
                                            พบว่าปี
                                            {{items.saleVal1_year_low}} มีค่าต่ำสุดที่
                                            {{items.saleVal1_year_low_num.toLocaleString("en-US")}}
                                            ลบ.
                                            และสูงสุดที่ปี {{items.saleVal1_year_max}}
                                            จำนวน {{items.saleVal1_year_max_num.toLocaleString("en-US")}} ลบ.
                                        </li>
                                    </ul>
                                </div>

                                <div class="col-8 mt-3 pt-2 profile-pdf2">
                                    <ul class="profile-pdf-list2">
                                        <li>
                                            <span class="pdf-text-green">ประเภทรวบรวมผลผลิต</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.collectVal1_year_now}}</span> จำนวน
                                            {{items.collectVal1_year_now_num.toLocaleString("en-US")}} ลบ.
                                            <span class="pdf-text-red">
                                                {{items.collectVal1_compare}}</span>
                                            จาก<span class="pdf-text-red">ปี
                                                {{items.collectVal1_year_last}}</span> จำนวน
                                            {{items.collectVal1_year_last_num.toLocaleString("en-US")}}
                                            ลบ.
                                            คิดเป็น {{items.collectVal1_cal_percent}}%
                                            จากข้อมูลปี {{items.collectVal1_year_low}} – {{items.collectVal1_year_max}}
                                            พบว่าปี
                                            {{items.collectVal1_year_low}} มีค่าต่ำสุดที่
                                            {{items.collectVal1_year_low_num.toLocaleString("en-US")}} ลบ.
                                            และสูงสุดที่ปี {{items.collectVal1_year_max}}
                                            จำนวน {{items.collectVal1_year_max_num.toLocaleString("en-US")}} ลบ.
                                        </li>

                                        <li>
                                            <span class="pdf-text-green">ประเภทแปรรูปผลผลิต</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.transformVal1_year_now}}</span> จำนวน
                                            {{items.transformVal1_year_now_num.toLocaleString("en-US")}} ลบ.
                                            <span class="pdf-text-red">
                                                {{items.transformVal1_compare}}</span>
                                            จาก<span class="pdf-text-red">ปี
                                                {{items.transformVal1_year_last}}</span> จำนวน
                                            {{items.transformVal1_year_last_num.toLocaleString("en-US")}}
                                            ลบ.
                                            คิดเป็น {{items.transformVal1_cal_percent}}%
                                            จากข้อมูลปี {{items.transformVal1_year_low}} –
                                            {{items.transformVal1_year_max}} พบว่าปี
                                            {{items.transformVal1_year_low}} มีค่าต่ำสุดที่
                                            {{items.transformVal1_year_low_num.toLocaleString("en-US")}} ลบ.
                                            และสูงสุดที่ปี {{items.transformVal1_year_max}}
                                            จำนวน {{items.transformVal1_year_max_num.toLocaleString("en-US")}} ลบ.
                                        </li>

                                        <li>
                                            <span class="pdf-text-green">ประเภทธุรกิจบริการ</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.serviceVal1_year_now}}</span> จำนวน
                                            {{items.serviceVal1_year_now_num.toLocaleString("en-US")}} ลบ.
                                            <span class="pdf-text-red">
                                                {{items.serviceVal1_compare}}</span>
                                            จาก<span class="pdf-text-red">ปี
                                                {{items.serviceVal1_year_last}}</span> จำนวน
                                            {{items.serviceVal1_year_last_num.toLocaleString("en-US")}}
                                            ลบ.
                                            คิดเป็น {{items.serviceVal1_cal_percent}}%
                                            จากข้อมูลปี {{items.serviceVal1_year_low}} – {{items.serviceVal1_year_max}}
                                            พบว่าปี
                                            {{items.serviceVal1_year_low}} มีค่าต่ำสุดที่
                                            {{items.serviceVal1_year_low_num.toLocaleString("en-US")}} ลบ.
                                            และสูงสุดที่ปี {{items.serviceVal1_year_max}}
                                            จำนวน {{items.serviceVal1_year_max_num.toLocaleString("en-US")}} ลบ.
                                        </li>
                                    </ul>
                                </div>
                                <div class="col-4" style="margin-top: 20px;">
                                    <!-- <div id="chartdivPDF1" class="chart"></div> -->
                                     <img class="people-pdf" src="assets/pdf/Group34224.png" alt="">
                                </div>
                            </div>
                        </ng-container>

                        <div class="row" style="margin-top: 2rem !important;">
                            <div class="col text-center">
                                <img class="group-img-title" src="assets/pdf/Group4582.png" alt="">
                            </div>
                        </div>

                        <ng-container *ngFor="let items of Coop_ReportProfileBussiness">
                            <div class="row mt-2 ml-2 mr-2">
                                <div class="col-6">
                                    <ul class="profile-pdf-list2">
                                        <li>
                                            <span class="pdf-text-blue">การมีส่วนร่วมของสมาชิกสหกรณ์</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.memberBusiness_year_now}}</span>
                                            จำนวน {{items.memberBusiness_year_now_num.toLocaleString("en-US")}} คน
                                            {{items.memberBusiness_compare}}
                                            จากปี {{items.memberBusiness_year_last}} จำนวน
                                            {{items.memberBusiness_year_last_num.toLocaleString("en-US")}} คน คิดเป็น
                                            {{items.memberBusiness_cal_percent}}%
                                        </li>

                                        <li>
                                            <span class="pdf-text-blue">ประเภทรับฝากเงิน</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.memDeposit_year_now}}</span>
                                            จำนวน {{items.memDeposit_year_now_num.toLocaleString("en-US")}} คน
                                            {{items.memDeposit_compare}}
                                            จากปี {{items.memDeposit_year_last}} จำนวน
                                            {{items.memDeposit_year_last_num.toLocaleString("en-US")}} คน คิดเป็น
                                            {{items.memDeposit_cal_percent}}%
                                        </li>

                                        <li>
                                            <span class="pdf-text-blue">ประเภทสินเชื่อ</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.memCredit_year_now}}</span>
                                            จำนวน {{items.memCredit_year_now_num.toLocaleString("en-US")}} คน
                                            {{items.memCredit_compare}}
                                            จากปี {{items.memCredit_year_last}} จำนวน
                                            {{items.memCredit_year_last_num.toLocaleString("en-US")}} คน คิดเป็น
                                            {{items.memCredit_cal_percent}}%
                                        </li>

                                        <li>
                                            <span class="pdf-text-blue">ประเภทจัดหาสินค้ามาจำหน่าย</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.memSal_year_now}}</span>
                                            จำนวน {{items.memSal_year_now_num.toLocaleString("en-US")}} คน
                                            {{items.memSal_compare}}
                                            จากปี {{items.memSal_year_last}} จำนวน
                                            {{items.memSal_year_last_num.toLocaleString("en-US")}} คน คิดเป็น
                                            {{items.memSal_cal_percent}}%
                                        </li>

                                        <li>
                                            <span class="pdf-text-blue">ประเภทแปรรูปผลผลิต</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.memGood_year_now}}</span>
                                            จำนวน {{items.memGood_year_now_num.toLocaleString("en-US")}} คน
                                            {{items.memGood_compare}}
                                            จากปี {{items.memGood_year_last}} จำนวน
                                            {{items.memGood_year_last_num.toLocaleString("en-US")}} คน คิดเป็น
                                            {{items.memGood_cal_percent}}%
                                        </li>

                                        <li>
                                            <span class="pdf-text-blue">ประเภทรวบรวมผลผลิต</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.memMarketing_year_now}}</span>
                                            จำนวน {{items.memMarketing_year_now_num.toLocaleString("en-US")}} คน
                                            {{items.memMarketing_compare}}
                                            จากปี {{items.memMarketing_year_last}} จำนวน
                                            {{items.memMarketing_year_last_num.toLocaleString("en-US")}} คน คิดเป็น
                                            {{items.memMarketing_cal_percent}}%
                                        </li>

                                        <li>
                                            <span class="pdf-text-blue">ประเภทธุรกิจบริการ</span>
                                            <span class="pdf-text-red"> ปี
                                                {{items.memService_year_now}}</span>
                                            จำนวน {{items.memService_year_now_num.toLocaleString("en-US")}} คน
                                            {{items.memService_compare}}
                                            จากปี {{items.memService_year_last}} จำนวน
                                            {{items.memService_year_last_num.toLocaleString("en-US")}} คน คิดเป็น
                                            {{items.memService_cal_percent}}%
                                        </li>

                                    </ul>
                                </div>

                                <div class="col-6 pl-2 pr-0 m-0">
                                    <div class="row p-0 m-0">
                                        <div class="col-11 p-0 m-0">
                                            <!-- <div class="row">
                                                <div class="col text-center"
                                                    style="background: linear-gradient(270deg, #742BFA 0%, #9A47E9 100%); border-radius: 10px 10px 0 0; color: #FFFFFF; font-size: 10px; font-weight: bold;">
                                                    จากจำนวนสมาชิกทั้งหมด 3,482 ราย สมาชิกมีส่วนร่วมในแต่ละธุรกิจของปี
                                                    {{year_now}}
                                                </div>
                                            </div> -->
                                            <div class="row">
                                                <div class="col-12" style="margin-top: 20px;">
                                                    <div id="chartdivPDF2" class="chart"></div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ng-container>


                    </div>

                    <div class="container-fluid p-2" *ngIf="pdfPage == 2">
                        <!-- <img class="bg-1" src="assets/pdf/A4-7.png" alt=""> -->

                        <div class="row ml-3 mr-3">
                            <div class="col text-center"
                                style="background: linear-gradient(270deg, #742BFA 0%, #9A47E9 100%); border-radius: 10px 10px 0 0; color: #FFFFFF; font-size: 12px; font-weight: bold;">
                                รายการอุปกรณ์การตลาด
                            </div>
                        </div>

                        <div class="row ml-3 mr-3">
                            <div class="col p-0">
                                <!-- <div class="table-responsive"> -->
                                <table class="table table-striped">
                                    <thead class="pdf-head-tbl">
                                        <tr>
                                            <th></th>
                                            <th class="text-center">จำนวน</th>
                                            <th class="text-center">กำลังการผลิต</th>
                                            <th class="text-center">หน่วยนับ(จำนวน)</th>
                                            <th class="text-center">งบปี</th>
                                        </tr>
                                    </thead>
                                    <tbody class="pdf-body-tbl">
                                        <tr *ngFor="let items of
                                            AssetYear;">
                                            <td>{{items.assetDesc}}</td>
                                            <td class="text-center">{{items.qty | number:'':'he'}}</td>
                                            <td class="text-center">{{items.size | number:'':'he'}}</td>
                                            <td class="text-center">{{items.sizeUom}}</td>
                                            <td class="text-center">{{items.purchaseYear}}</td>
                                        </tr>
                                    </tbody>
                                </table>
                                <!-- </div> -->
                            </div>
                        </div>

                        <div class="row mt-4">
                            <div class="col text-center" style="font-size: 12px; font-weight: bold;">
                                ข้อมูลพื้นที่เพาะปลูก
                            </div>
                        </div>

                        <div class="row mt-2 ml-3 mr-3" *ngIf="Coop_ReportOae && Coop_ReportOae.length > 0">
                            <div class="col-6">
                                <div class="row">
                                    <div class="col text-center pdf-text-blue"
                                        style="font-size: 12px; font-weight: bold;">
                                        ทะเบียนเกษตรกร ที่มีจำนวนสมาชิก
                                        <br>
                                        มากสุด 3 อันดับแรกคือ
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col text-center p-0 m-0">
                                        <img class="img-oae" src="assets/pdf/Group4555.png" alt="">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col pl-3">
                                        <ul class="profile-pdf-list3">
                                            <li>
                                                {{Coop_ReportOae[0].group1_1_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group1_1_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group1_1_rai}}
                                                ไร่
                                            </li>
                                            <li>
                                                {{Coop_ReportOae[0].group1_2_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group1_2_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group1_2_rai}}
                                                ไร่
                                            </li>
                                            <li>
                                                {{Coop_ReportOae[0].group1_3_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group1_3_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group1_3_rai}}
                                                ไร่
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="row">
                                    <div class="col text-center pdf-text-blue"
                                        style="font-size: 12px; font-weight: bold;">
                                        ทะเบียนเลี้ยงสัตว์ ที่มีจำนวนสมาชิก
                                        <br>
                                        มากสุด 3 อันดับแรกคือ
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col text-center p-0 m-0">
                                        <img class="img-oae" src="assets/pdf/Group4556.png" alt="">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col pl-3">
                                        <ul class="profile-pdf-list3">
                                            <li>
                                                {{Coop_ReportOae[0].group2_1_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group2_1_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group2_1_rai}}
                                                ไร่
                                            </li>
                                            <li>
                                                {{Coop_ReportOae[0].group2_2_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group2_2_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group2_2_rai}}
                                                ไร่
                                            </li>
                                            <li>
                                                {{Coop_ReportOae[0].group2_3_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group2_3_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group2_3_rai}}
                                                ไร่
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="row" *ngIf="Coop_ReportOae && Coop_ReportOae.length > 0">
                            <div class="col-3 p-0 m-0 text-center">
                                <img class="img-oae" src="assets/pdf/Group4557.png" alt="">
                            </div>
                            <div class="col-4">
                                <div class="row">
                                    <div class="col text-center pdf-text-blue"
                                        style="font-size: 12px; font-weight: bold;">
                                        ทะเบียนประมง ที่มีจำนวนสมาชิก
                                        <br>
                                        มากสุด 3 อันดับแรกคือ
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col pl-3">
                                        <ul class="profile-pdf-list3">
                                            <li>
                                                {{Coop_ReportOae[0].group3_1_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group3_1_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group3_1_rai}}
                                                ไร่
                                            </li>
                                            <li>
                                                {{Coop_ReportOae[0].group3_2_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group3_2_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group3_2_rai}}
                                                ไร่
                                            </li>
                                            <li>
                                                {{Coop_ReportOae[0].group3_3_name}} จำนวนสมาชิก
                                                {{Coop_ReportOae[0].group3_3_member}} คน จำนวน
                                                {{Coop_ReportOae[0].group3_3_rai}}
                                                ไร่
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div class="col">
                                <div class="row">
                                    <div class="col p-0 m-0 text-center">
                                        <img class="img-oae" src="assets/pdf/forest1.png" alt="">
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col">
                                        ทะเบียนผู้ปลูกยาง จำนวนสมาชิก
                                        {{ViewRubberOracleSumYear && ViewRubberOracleSumYear.length > 0 ?
                                        ViewRubberOracleSumYear[0].totalCount.toLocaleString("en-US") : "0"}}
                                        คน จำนวน
                                        {{ViewRubberOracleSumYear && ViewRubberOracleSumYear.length > 0 ?
                                        ViewRubberOracleSumYear[0].totalRai.toLocaleString("en-US") : "0"}} ไร่
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

                <div class="row">
                    <div class="col" style="text-align: end;">

                        <button class="btn btn-success mr-3" style="width: 35px;" *ngIf="pdfPage > 0"
                            (click)="changePagePDF(0)">
                            < </button>
                                <button class="btn btn-success mr-3" style="width: 35px;" *ngIf="pdfPage < 2"
                                    (click)="changePagePDF(1)"> >
                                </button>
                                <button class="btn btn-success w-25 mr-3" (click)="exportAllToPDF()"> Export</button>
                                <button class="btn btn-primary w-25 mr-3" data-dismiss="modal"> ปิด</button>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
